"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const initSlider = document.querySelector(
            ".o-diferenciais-cards__cards"
        );
        if (!initSlider) return;

        const swiper = new Swiper(".o-diferenciais-cards__cards", {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            breakpoints: {
                680: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 4,
                },
            },
        });
    });
}
